import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Snackbar from '@material-ui/core/Snackbar';

import { getSelector } from 'redux/selectors';
import { setHotNotification } from 'redux/ui/actions';
import HotNotificationContent from './HotNotificationContent';

export class Notification extends Component {
  static propTypes = {
    hotNotification: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),

    setHotNotification: PropTypes.func.isRequired,
  };

  static defaultProps = {
    hotNotification: '',
  };

  state = {
    open: false,
    currentElement: null,
  };

  componentWillReceiveProps({ hotNotification }) {
    if (hotNotification) {
      this.setState({ open: true });
    }
  }

  handleRequestClose = (event, reason) => {
    const { setHotNotification } = this.props;
    const { currentElement } = this.state;
    if (reason === 'clickaway' && event.target.type === 'number' && (!currentElement || event.target === currentElement || (event.target !== currentElement && currentElement.type === undefined))) {
      this.setState({ currentElement: event.target });
      return;
    }
    this.setState({ currentElement: event.target });
    setHotNotification('');
    this.setState({ open: false });
  };

  render() {
    const { open } = this.state;
    const { hotNotification } = this.props;
    let autoHideDuration;
    let message;

    if (typeof hotNotification === 'object') {
      autoHideDuration = hotNotification.autoHideDuration || null;
      message = hotNotification.message || '';
    } else {
      autoHideDuration = null;
      message = hotNotification;
    }

    return (
      <Snackbar
        autoHideDuration={autoHideDuration}
        onClose={this.handleRequestClose}
        open={open && !!message}
      >
        <HotNotificationContent
          message={message}
          onClose={this.handleRequestClose}
          variant="error"
        />
      </Snackbar>
    );
  }
}

/* istanbul ignore next */
const mapStateToProps = state => ({
  hotNotification: getSelector('ui', 'hotNotification')(state),
});

/* istanbul ignore next */
const mapDispatchToProps = dispatch => ({
  setHotNotification: hotNotification => dispatch(setHotNotification(hotNotification)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Notification);
